import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { EnvironmentService } from "@services/environment.service";
import { HttpUtilService } from "@services/http-util.service";
import { PageTitleService } from "@services/page-title.service";

@Component({
  selector: "app-account-select",
  templateUrl: "./account-select.component.html",
  styleUrls: ["./account-select.component.scss"],
})
export class AccountSelectComponent implements OnInit {
  public view;
  constructor(
    private pageTitleService:PageTitleService,
    private http: HttpUtilService,
    private environmentService: EnvironmentService
  ) {}

  ngOnInit(): void {
    this.http
      .request('get',
        `${this.environmentService.environment.apiRoot}/accounts/accounts_select?mode=read`,null,null,true
      )
      .subscribe((c) => {
        if (c != null) {
          this.view = c;
        }
      });
      this.pageTitleService.section ="Accounts";
  }
}
